<template>
  <div>
    <!-- <pre>
     {{ time_table }}
   </pre
    > -->
    <div class="bg-[#BDBDBD] flex h-[300px] w-full justify-center items-center">
      <div>
        <v-radio-group v-model="selected_time">
          <div
            class="
              flex
              border-2
              rounded-lg
              border-gray-500
              grow
              text-center
              p-4
              bg-white
              flex-col flex-wrap
              h-[180px]
              w-[600px]
            "
          >
            <div v-for="(item, i) in time_table" :key="i">
              <!-- <div>
              <div>{{ item.time_table }} {{ item.am_pm }}</div>
            </div> -->
              <div class="flex">
                 <v-radio
                  id=i
                  :value="item"
                >
                </v-radio>
                <label for="i">{{item.time_table}} - {{ item.am_pm}}</label>
               
              </div>
            </div>
          </div>
        </v-radio-group>
        <!-- {{selected_time}} -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      selected_time: null,
      time_table: [],
    };
  },

  watch: {
    selected_time: {
      handler(e) {
        this.$emit("on_selected_time", e);
      },
      immediate: true,
    },
    "$route.name": {
      handler() {
        this.getTimeTableValues();
      },
      immediate: true,
    },
  },
  methods: {
    getTimeTableValues() {
      axios.get("/time_table/get").then((res) => {
        this.time_table = res.data;
      });
    },
  },
};
</script>

<style scoped>
.btn:active {
  background: #ccc;
}
.btn:focus {
  background: #ccc;
}
.btn:hover {
  background: #ccc;
}
</style>